
























































































































































import {
    Component, Mixins, Model, Prop, Watch,
} from 'vue-property-decorator';
import { DELETE_TEMPLATE, RENAME_TEMPLATE } from '@/store/modules/template';
import CustomDialog from '@/components/global/CustomDialog.vue';
import { MUTATE_SHOW_UPGRADE_PLAN } from '../../../store/modules/interface';
import { ProductTemplate } from '@/assets/interface/Product';
import SimpleDialog from '@/components/global/SimpleDialog.vue';
import TemplateIntegrationMixin from '@/mixins/vue/TemplateIntegrationMixin';
import { findIndex } from 'lodash';
import freePlan from '@/assets/free-config';
import index from '@/store';
import { product } from '@/plugins/papybase/papybaseInit';

@Component({
    components: {
        CustomDialog,
        SimpleDialog,
    },
})
export default class SaveTemplateDialog extends Mixins(TemplateIntegrationMixin) {
    @Model('update:saveTemplateDialogValue', { type: Boolean }) readonly value!: boolean;

    public saveDialogLoading = false;

    public replaceConfirmationDialog = false;
    public productTemplate = '';

    public activeId = -1;
    public activeList = -1;
    public renameActiveList = -1;
    public renameModel = ''

    public items = [
        { title: 'Rename' },
        { title: 'Delete' },
    ];

    public x = 0;
    public y = 0;

    public showMenu = false;

    public saveTemplateDialogEvent(action: string, label: any) {
        this.$ga.event('SaveTemplateDialog', 'click', action, label);
    }

    public onMenuClick(type: string) {
        this.saveTemplateDialogEvent(type, type);
        if (type === 'Rename') {
            this.renameActiveList = this.activeList;
        } else if (type === 'Delete') {
            const productId = this.templateList[this.activeList].id;
            product.deleteProductByID(this.jwt, productId).then((res) => {
                if (res) {
                    this.$store.commit(DELETE_TEMPLATE, productId);
                }
            });
        }
    }

    public onCancelClick(event: any) {
        this.saveTemplateDialogEvent('click cancel', 'Cancel');
        this.emitReturnValue(event);
    }

    public onSaveClick() {
        this.saveTemplateDialogEvent('click save', 'save');
        this.getTemplate(this.productTemplate).then((res) => {
            if (!res) {
                this.save();
            } else {
                this.activeId = res.id;
                this.replaceConfirmationDialog = true;
            }
        }).catch((err) => {
            console.error(err);
        });
    }

    public onClick(i: number) {
        this.saveTemplateDialogEvent('click item', i);
        this.activeList = i;
        this.productTemplate = this.templateList[i].productTemplate!;
    }

    public onRightClick(e: any, i:number) {
        this.saveTemplateDialogEvent('right click item', i);
        if (i !== this.renameActiveList) {
            this.activeList = i;
            this.onShowMenu(e.clientX, e.clientY);
        }
    }

    public onDblClick(i: number) {
        this.saveTemplateDialogEvent('double click item', i);
        this.activeId = this.templateList[i].id;
        if (i !== this.renameActiveList) {
            this.replaceConfirmationDialog = true;
        }
    }

    public onPress(e: any, i: number) {
        this.saveTemplateDialogEvent('press item', i);
        if (i !== this.renameActiveList) {
            this.activeList = i;
            this.onShowMenu(e.center.x - 5, e.center.y - 5);
        }
    }

    public onShowMenu(xAxis: number, yAxis: number) {
        this.showMenu = false;
        this.x = xAxis;
        this.y = yAxis;
        this.$nextTick(() => {
            this.showMenu = true;
        });
    }

    public onReplaceConfirmation(isReplace: boolean) {
        if (isReplace) {
            this.save(true);
        }
    }

    public async save(isReplace = false) {
        this.saveDialogLoading = true;
        if (!await this.isSaveAllowed() && !isReplace) {
            // if this feature allowed by the suscribtion
            this.$store.commit(MUTATE_SHOW_UPGRADE_PLAN, true);
        } else if (isReplace) {
            this.$emit('replaceClick', {
                productTemplate: this.productTemplate,
                id: this.activeId,
            });
            this.emitReturnValue(false);
        } else {
            this.$emit('saveClick', this.productTemplate);
            this.emitReturnValue(false);
        }
        this.saveDialogLoading = false;
    }

    public async isSaveAllowed() {
        return this.$store.getters.getAuth.user.confirmed;
    }

    public async rename(i: number) {
        const payload = {
            oldName: this.templateList[i].productTemplate,
            newName: this.renameModel,
        };

        if (payload.oldName === payload.newName) {
            return;
        }

        const template = await this.getTemplate(this.renameModel);
        if (template) {
            // eslint-disable-next-line
            alert(`The name "${this.renameModel}" is already taken. Please choose a different name.`);
            return;
        }

        if (this.renameModel.trim().length > 0) {
            product.updateProductByID(this.jwt, {
                id: this.templateList[i].id,
                productTemplate: this.renameModel,
            }).then((res) => {
                this.$store.commit(RENAME_TEMPLATE, payload);
            }).catch((err) => {
                console.error(err);
            });
        }
    }

    public emitReturnValue(event: any) {
        this.activeList = -1;
        this.$emit('update:saveTemplateDialogValue', event);
    }

    get templateList() {
        return (this.$store.getters.getTemplates);
    }

    @Watch('activeList')
    private onActiveListChange(val: boolean) {
        this.renameActiveList = -1;
    }

    @Watch('renameActiveList')
    private onRenameActiveListChange(val: number) {
        if (val !== -1) {
            this.renameModel = this.templateList[this.activeList].productTemplate!;
        }
    }
}
